export default __webpack_public_path__ + "static/media/cleophee.99b098cd.jpg";